export const ExtractionReason = {
  /* @deprecated */
  MISSING_DOCUMENT: "missing_document",
  AUTH_ERROR: "auth_error",
  ADMIN_FAILURE: "admin_failure",
  SESSION_FLOW_ERROR: "session_flow_error",
  /* @deprecated */
  ACTION_REQUIRED_FROM_USER: "action_required_from_user",
  PENDING_ON_ASYNC_EXTRACTION: "pending_on_async_extraction",
  BAD_CONFIGURATION: "bad_configuration",
  BLOCKED_CREDENTIALS: "blocked_credentials",
  DOCUMENT_NOT_FOUND: "document_not_found",
  DOCUMENT_RESOLUTION_PENDING: "document_resolution_pending",
  GENERIC: "generic",
  GENERIC_ADMINISTRATION_UNAVAILABLE: "generic_administration_unavailable",
  LOGIN_METHOD_SESSION_EXPIRED: "login_method_session_expired",
  MFA_METHOD_NOT_SUPPORTED: "mfa_method_not_supported",
  NO_LOGIN_METHODS_AVAILABLE: "no_login_methods_available",
  REPRESENTATION_REQUIREMENTS_NOT_MET: "representation_requirements_not_met",
  TIMEOUT: "timeout",
  USER_ABORTED: "user_aborted",
  USER_BLOCKED: "user_blocked",
  USER_DISABLED: "user_disabled",
  USER_NOT_AUTHENTICATED: "user_not_authenticated",
  USER_NOT_REGISTERED: "user_not_registered",
  USER_UNKNOWN: "user_unknown",
  UNKNOWN: "unknown",
} as const;

export type KnownExtractionReason = (typeof ExtractionReason)[keyof typeof ExtractionReason];
export type ExtractionReason = KnownExtractionReason | (string & {});
